import { adminSettingsPermissions } from "../../routes/useAdminSettingsNavigation";
import { useFetchPermissions } from "../../services/admin-settings/admin-settings";

// Admin OR recruiter permissions for Userpilot gating
// TODO: potentially extract publish job post permission constant
const ATS_QUALIFYING_PERMISSIONS = [
  adminSettingsPermissions.rolesAndPermissions,
  "publish:job-post",
];

/**
 * Whether the current user should receive Userpilot in-app messages based on their ATS role
 * (ATS Admin or Recruiter). See useCanReceiveUserpilotAsHr for the HR-side equivalent and for
 * why both route through admin-settings.ts's useFetchPermissions, and for why no loading state
 * is exposed here.
 */
export function useCanReceiveUserpilotAsAts(): boolean {
  const { hasPermission } = useFetchPermissions("ats");

  return ATS_QUALIFYING_PERMISSIONS.some((permission) => hasPermission(permission));
}
